import Vue from "vue";
import url from "./apiurls";
import { store } from "../store/store";

export const videoApi = new Vue({
  methods: {
    getAllCourses() {
      return new Promise((resolve, reject) => {
        this.$http
          .get(url.getAllCourses)
          .then(res => {
            resolve(res);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    getCourseByCategory(categoryId) {
      return new Promise((resolve, reject) => {
        const getUrl = `${url.getCourseByCategory}${categoryId}`;
        this.$http
          .get(getUrl)
          .then(res => {
            resolve(res);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    getCourseByCourseId(courseId) {
      return new Promise((resolve, reject) => {
        const getUrl = `${url.getCourseByCourseId}${courseId}`;
        this.$http
          .get(getUrl)
          .then(res => {
            resolve(res);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    getCategory() {
      return new Promise((resolve, reject) => {
        this.$http
          .get(url.getCategory)
          .then(res => {
            resolve(res);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    getCourseReview() {
      return new Promise((resolve, reject) => {
        this.$http
          .get(url.getCourseReview)
          .then(res => {
            resolve(res);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    getAllLiveCourses() {
      return new Promise((resolve, reject) => {
        this.$http
          .get(url.getLiveCourses)
          .then(res => {
            resolve(res);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    getLIveCoursesByCategory(categoryId) {
      return new Promise((resolve, reject) => {
        const getUrl = `${url.getLiveCoursesByCategory}${categoryId}`;
        this.$http
          .get(getUrl)
          .then(res => {
            resolve(res);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    getLiveCoursesByCourseId(courseId) {
      return new Promise((resolve, reject) => {
        const getUrl = `${url.getLiveByCourseId}${courseId}`;
        this.$http
          .get(getUrl)
          .then(res => {
            resolve(res);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    filterAllCourses(filterData) {
      return new Promise((resolve, reject) => {
        this.$http
          .post(url.filterAllCourses, filterData)
          .then(res => {
            resolve(res);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    filterCoursesByCategory(filterData) {
      return new Promise((resolve, reject) => {
        this.$http
          .post(url.filterCoursesByCategory, filterData)
          .then(res => {
            resolve(res);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    filterLiveCourses(filterData) {
      return new Promise((resolve, reject) => {
        this.$http
          .get(url.filterLiveCourses, filterData)
          .then(res => {
            resolve(res);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    filterLiveCoursesByCategory(filterData) {
      return new Promise((resolve, reject) => {
        this.$http
          .get(url.filterLiveCoursesByCategory, filterData)
          .then(res => {
            resolve(res);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    searchKeys(searchKey) {
      return new Promise((resolve, reject) => {
        const getUrls = `${url.searchKeys}${searchKey}`;
        this.$http
          .get(getUrls)
          .then(res => {
            resolve(res);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    searchCourses(searchKey) {
      return new Promise((resolve, reject) => {
        const getUrls = `${url.searchCourses}${searchKey}`;
        this.$http
          .get(getUrls)
          .then(res => {
            resolve(res);
          })
          .catch(e => {
            reject(e);
          });
      });
    }
  }
});
